import { Cross1Icon } from "../Icons"
import { getButtonCss, BaseButtonProps } from "../Button/ButtonStyles"
import { styled, StyleProps } from "../styles"

interface RemoveButtonProps extends BaseButtonProps {
  cursor: `default` | `notAllowed`
}

type RemoveProps = React.ComponentPropsWithRef<typeof RemoveButton> & RemoveButtonProps

const Remove = (props: RemoveProps) => (
  <RemoveButton {...props}>
    <Cross1Icon />
  </RemoveButton>
)

type RemoveButtonStyledProps = RemoveButtonProps & StyleProps

const RemoveButton = styled.button<RemoveButtonProps>((props: RemoveButtonStyledProps) => ({
  ...getButtonCss(props),
  display: `flex`,
  alignItems: `center`,
  justifyContent: `center`,
  borderRadius: props.theme.borderRadius.sm,
  backgroundColor: props.theme.palette.coal.dark,
  color: props.theme.palette.white,
  marginLeft: props.theme.spacing(5),
  padding: props.theme.spacing(4),
  cursor: props.cursor === `notAllowed` ? `not-allowed` : `default`,
}))

Remove.displayName = `InputGroup.Remove`

export { Remove }
